export default "__VITE_ASSET__CGBQg1eu__"